import * as React from "react";
import Stars02 from "../../icons/v2-stroke/Stars02";

// Fork (Astraly) : remplace les logos carrés de Dust (voir index.ts).
const LogoNeutreCarre = props => /*#__PURE__*/React.createElement(Stars02, {
  ...props
});
export default LogoNeutreCarre;
//# sourceMappingURL=LogoNeutreCarre.js.map